import { instance as axios } from "@/hooks/axios/axios.js";
// import router from "@/router/router";

import errorHandler from "@/store/errors/errorHandler.js";
const AUTH_CHAT_ENDPOINT = process.env.VUE_APP_PUSHER_ENDPOINT;

export const chat  = (router) => ({
  state: {
    unread: false,
    list: [],
    messages: [],
    user: {
      name: null,
      id: null,
      image: null,
      preferredName:null
    },
    nextShift: {
      date: null,
      id: null,
    },
    auth: null,
  },
  getters: {
    GET_CHAT_DATA: (state) => state,
    GET_CHAT_LIST: (state) => state.list,
    GET_CHAT_MESSAGES: (state) => state.messages,
  },
  mutations: {
    AUTH_CHAT(state, data) {
      state.auth = data;
    },
    SET_CHAT_LIST(state, data) {
      state.list = data;
    },
    SET_CHAT_LAST_MESSAGE(state, data) {
      const chat = data.data.data;
      state.list.find((x, i) => {
        if (x.chatId == chat.chat_id) {
          state.list.splice(i, 1);
          return true;
        } else return false;
      });
      state.list.unshift({
        chatId: chat.chat_id,
        unread: chat.unread,
        user: chat.user,
        image: chat.image,
        message: chat.message,
        date: chat.date,
      });
      // }
    },
    SET_CHAT_MESSAGES(state, data) {
      state.messages = data.messages;
      state.user.name = data.userName;
      state.user.id = data.userId;
      state.user.image = data.userImage;
      state.nextShift.date = data.nextShiftDate;
      state.nextShift.id = data.nextShiftId;
    },
    ADD_CHAT_MESSAGE(state, data) {
      if (data.queue) {
        const messagePosition = state.messages.length - data.queue;
        state.messages[messagePosition] = data;
      } else {
        state.messages.push(data);
      }
    },
    SET_CHAT_UNREAD_MESSAGES(state, data) {
      state.unread = data;
    },
  },
  actions: {
    async AUTH_CHAT(store) {
      try {
        const resp = await axios.get(AUTH_CHAT_ENDPOINT);
        store.commit("AUTH_CHAT", resp.data.data);
      } catch (error) {
        errorHandler(error);
      }
    },
    async GET_CHAT_LIST(store) {
      try {
        const resp = await axios.get("/chat/list", {});
        store.commit("SET_CHAT_LIST", resp.data.data);
        store.dispatch("CHECK_CHAT_UNREAD_MESSAGES");
      } catch (error) {
        errorHandler(error);
      }
    },
    async GET_CHAT_MESSAGES(store, data, params) {
      try {
        let url = "/chat/" + data;
        const resp = await axios.get(url, {
          params: params,
        });
        store.commit("SET_CHAT_MESSAGES", resp.data.data);
      } catch (error) {
        
        if (error.response.status === 400) {
          router.push({ name: "NotFound" });
        }
      }
    },

    async SEND_CHAT_MESSAGE(store, data) {
      try {
        let url = "/chat/message";
        await axios.post(url, data);
      } catch (error) {
        errorHandler(error);
      }
    },

    CHECK_CHAT_UNREAD_MESSAGES(store) {
      const list = store.getters.GET_CHAT_LIST;
      if (list.some((x) => x.unread > 0)) {
        store.commit("SET_CHAT_UNREAD_MESSAGES", true);
      } else {
        store.commit("SET_CHAT_UNREAD_MESSAGES", false);
      }
    },

    async MARK_CHAT_MESSAGE_AS_READ(store, data) {
      try {
        let url = "/chat/message/mark-as-read";
        await axios.post(url, data);
      } catch (error) {
        errorHandler(error);
      }
    },
  },
});
